import React, { useEffect, useState, SyntheticEvent } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../Navbar/index';
import { MdVerified } from 'react-icons/md';
import { Rating } from 'react-simple-star-rating';
import { connect } from 'react-redux';
import { TextField } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import { PerfilTypesToken } from '../../Types/PerfilTypes';
import { FcLikePlaceholder, FcLike } from 'react-icons/fc';
import serviceImg from '../../Assets/Imagenes/blank-service-picture.png';
import Footer from '../Footer';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import wabutton from '../../Assets/Imagenes/wa_esp.png';
import HirePetSitterForm from '../Servicios/formHirePetSitter';
import './showPetsitters.css';
import ReportForm from '../Perfil/ReportForm';
function mapStateToProps(state: any) {
  return { action: state }; // this will be available in HomeScreen as props.action
}

function PetsitterShow(props: PerfilTypesToken) {
  const [canRate, setCanRate] = useState(true);
  const { id } = useParams();
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState<Array<any>>([]);
  const [like, setLike] = useState(false);
  const [likes, setLikes] = useState(0);
  const [num, setNum] = useState('');
  const [whatsApp, setWhatsApp] = useState<string>('');
  const [hoverVerified, setHoverVerified] = useState(false);
  const [petSitterService, setPetSitterService] = useState(false);
  const [profileImg, setProfileImg] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [addressComuna, setAddressComuna] = useState<string>('');
  const [addressRegion, setAddressRegion] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [petsitterId, setPetsitterId] = useState<string>('');
  const [verified, setVerified] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [rating, setRating] = useState<number>(0);

  async function fetchPetsitter() {
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.get(`${process.env.REACT_APP_URL}/petsitters/${id}/`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        console.log(res.data);
        fetchCommentsPetsitter(res.data.petsitter.id);
        getLikesPetsitter(res.data.petsitter.id);
        availableToLike(res.data.petsitter.id);
        setProfileImg(res.data.petsitter.IsPetsitter[0].profileUrlImg);
        setPetsitterId(res.data.petsitter.id);
        setAddressComuna(res.data.petsitter.IsPetsitter[0].addressComuna);
        setAddressRegion(res.data.petsitter.IsPetsitter[0].addressRegion);
        setDescription(res.data.petsitter.IsPetsitter[0].description);
        setCanRate(res.data.available);
        setRating(res.data.petsitter.IsPetsitter[0].score);
        setEmail(res.data.petsitter.email);
        setName(res.data.petsitter.IsPetsitter[0].name);
        setVerified(res.data.petsitter.ispetsitter);
        const numArray = res.data.petsitter.phone.split('');
        const formattedNum = `(${numArray.slice(0, 4).join('')}) ${numArray.slice(4, 8).join('')} ${numArray.slice(8, 12).join('')}`;
        if (res.data.petsitter.phone.slice(0, 4) === '+569') {
          setWhatsApp(res.data.petsitter.phone.slice(1));
        } else {
          setWhatsApp('');
        }
        setNum(formattedNum);
        console.log(petsitterId);
        axios.get(`${process.env.REACT_APP_URL}/petsitterReviews/availability/${res.data.petsitter.id}/${props.action.user.credenciales.id}`, { headers: { Authorization: `Bearer ${token}` } })
          .then(res2 => {
            console.log(res2.data);
          });
      });
  }

  async function ratePetsitter(rate: number) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.post(`${process.env.REACT_APP_URL}/petsitterReviews/${petsitterId}/`, {
      userId: props.action.user.credenciales.id,
      score: rate
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  useEffect(() => {
    fetchPetsitter();
  }, []);

  function handleRating(rate: number) {
    setRating(rate);
    setCanRate(false);
    ratePetsitter(rate);
  }

  function handleComment(e: any) {
    setComment(e.target.value);
  }

  const InfoField = ({ label, value }: { label: string; value: string }) => (
    <div className="field-block">
      <div className="field-label">{label}</div>
      <div className="field-value">{value}</div>
    </div>
  );

  function availableToLike(id: string) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    axios.get(`${process.env.REACT_APP_URL}/likepetsitter/available/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      setLike(!res.data.available);
    });
  }

  function handleCommentSubmit() {
    const token = JSON.parse(localStorage.getItem('token') || '');
    axios.post(`${process.env.REACT_APP_URL}/commentPetsitter/addcomment/${petsitterId}`, {
      content: comment
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(() => {
      window.location.reload();
    });
  }

  function deleteComment(id: string) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    axios.delete(`${process.env.REACT_APP_URL}/commentPetsitter/deletecomment/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(() => {
      window.location.reload();
    });
  }

  function handleLikeSubmit() {
    const token = JSON.parse(localStorage.getItem('token') || '');
    if (!like) {
      axios.post(`${process.env.REACT_APP_URL}/likePetsitter/like/${petsitterId}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setLikes(response.data.totalLikes);
        setLike(!like);
      });
    } else {
      axios.delete(`${process.env.REACT_APP_URL}/likePetsitter/unlike/${petsitterId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setLikes(response.data.newTotalLikes || 0);
        setLike(!like);
        console.log(response.data.newTotalLikes);
      });
    }
  }

  function getLikesPetsitter(id: any) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    axios.get(`${process.env.REACT_APP_URL}/likePetsitter/getlikes/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLikes(response.data.totalLikes);
    });
  }

  function fetchCommentsPetsitter(id: any) {
    const token = JSON.parse(localStorage.getItem('token') || '');
    axios.get(`${process.env.REACT_APP_URL}/commentPetsitter/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setComments(response.data.comments.map((com: any) => ({ name: com.user.name, value: com.userId, label: com.content, id: com.id, userId: com.userId })));
    });
  }

  function togglePetSitterService(event: SyntheticEvent) {
    event.preventDefault();
    setPetSitterService(!petSitterService);
  }

  function togglePetSitterForm(event: SyntheticEvent) {
    event.preventDefault();
    setPetSitterService(!petSitterService);
  }

  return (
    <div className="wrapper">
      <link rel="stylesheet" href="path/to/font-awesome/css/font-awesome.min.css"></link>
      <Navbar logged={true} />
      <div className='spacer32'></div>
      <h6 className='navigation-info-post-post ms-3'>Petsitters / {name}</h6>
      <div className='spacer32'></div>
      <div className='container-perfil' style={{ flexGrow: 1 }}>
        <ReportForm />
        <div className='col-auto' style={{ width: '100%' }}>
          <div className='row' style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignContent: 'center', margin: '0px' }}>
            <div className='col-auto'>
              <div className='row'>
                <div className='col-auto'>
                  <div className='Box-foto'>
                    <img src={profileImg || serviceImg} alt='Image of a petsitter' style={{ borderRadius: '10px', backgroundImage: 'none', width: '15rem' }} />
                  </div>
                  <div className='spacer20'></div>
                  <div style={{ display: 'flex' }}>
                    <h4> {likes} likes</h4>
                    <div style={{ marginLeft: '150px' }}>
                      {like ? <FcLike size={35} onClick={handleLikeSubmit}></FcLike> : <FcLikePlaceholder size={35} onClick={handleLikeSubmit}></FcLikePlaceholder>}
                    </div>
                  </div>
                </div>
                <div className='col-auto' style={{ marginLeft: '58px', padding: '0px' }}>
                  <div className='row'>
                    {verified === 'YES'
                      ? <div style={{ position: 'relative' }} className='col-auto texto-nombre'>
                        {name}
                        <MdVerified
                          onMouseOver={() => setHoverVerified(true)}
                          onMouseOut={() => setHoverVerified(false)}
                          style={{ fill: '#C75100', cursor: 'pointer', marginLeft: '8px' }}
                        />
                        {hoverVerified &&
                          <span style={{
                            position: 'absolute',
                            backgroundColor: '#C75100',
                            border: 'solid',
                            borderColor: '#C75100',
                            color: 'white',
                            padding: '5%',
                            fontSize: '16px',
                            borderRadius: '5px',
                            bottom: '60px',
                            width: '600px',
                            right: '-550px',
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'
                          }}>
                            <table className='table-verified'>
                              <tbody>
                                <h4><tr><b>Petsitter verificado:</b></tr></h4>
                                <tr>- Ha pasado por un control de identidad.</tr>
                                <tr>- Ha sido seleccionado y aprobado por nuestro equipo.</tr>
                                <tr>- Es un estudiante, técnico o profesional de medicina veterinaria.</tr>
                              </tbody>
                            </table>
                          </span>
                        }
                      </div>
                      : <div className='col-auto texto-nombre'>
                        {name}
                      </div>
                    }

                    {
                      whatsApp !== '' &&
                      <div className='box-whatsapp'>
                        <a href={`https://wa.me/${whatsApp}?text=Hola!%20Quiero%20consultar%20por%20su%20anuncio%20de%20petsitter%20en%20Vepet.`}>
                          <img alt="Chat on WhatsApp" src={wabutton} />
                        </a>
                      </div>
                    }
                    <div className='box-whatsapp'>
                      <button
                        className="petsitter-hire-button"
                        onClick={(e) => togglePetSitterService(e)}>Contratar Petsitter</button>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-auto texto-mail'>
                      {email}
                    </div>
                  </div>
                  <div className='row' style={{ marginTop: '20px' }}>
                    <div className='col-auto' style={{ marginRight: '58px' }}>
                      {canRate && <Rating
                        onClick={handleRating}
                        allowFraction={true}
                        fillIcon={null}
                        showTooltip={true}
                        tooltipDefaultText='Califica al petsitter '></Rating>
                      }
                    </div>
                    <div className='spacer12'></div>
                    <div className='col-auto texto-mail'> Calificación: {rating.toFixed() + '/5'} ⭐</div>
                  </div>
                  <div className='row' style={{ marginTop: '5px', marginLeft: '5px' }}>
                    <TextField
                      inputProps={{ maxLength: 90 }}
                      id="standard-basic"
                      label="Agregar comentario"
                      variant="standard"
                      color='warning'
                      onChange={handleComment}
                      maxRows='1'
                    />
                    <div className='col-auto' style={{ padding: '0px' }}>
                      <button className="petsitter-hire-button" style={{ marginTop: '10px' }} onClick={handleCommentSubmit}>
                        Enviar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="petsitter-info-container">
            <div className="section-title">Información del Petsitter</div>

            <div className="info-grid">
              <div className="info-column">
                <InfoField label="Teléfono" value={num} />
                <InfoField label="Región" value={addressRegion} />
                <InfoField label="Comuna" value={addressComuna} />
                <InfoField label="Descripción" value={description} />
              </div>
            </div>
          </div>

          <div className="comments-section">
            <div className="section-title">Comentarios</div>
            <div className="comments-wrapper">
              {comments.length > 0 ? (
                comments.map((vet) => (
                  <Card key={vet.id} className="comment-card">
                    <CardContent>
                      <Typography variant="body1" className="comment-text">
                        {vet.label}
                        {vet.userId === props.action.user.credenciales.id && (
                          <button
                            className="delete-comment-button"
                            onClick={() => deleteComment(vet.id)}
                          >
                            Eliminar
                          </button>
                        )}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {vet.name}
                      </Typography>
                    </CardContent>
                  </Card>
                ))
              ) : (
                <Typography className="no-comments">
                  <WarningAmberRoundedIcon color="warning" style={{ marginRight: '6px' }} />
                  No hay comentarios aún
                </Typography>
              )}
            </div>
          </div>
          <div style={{ margin: '1rem' }}><Link to='/petsitters' className='link-back-veterinarians-show'>Volver</Link></div>
        </div>
        {petSitterService === true && (
          <div className="register-form-container">
            <div className="register-form-content">
              <HirePetSitterForm
                toggleHirePetsitter={togglePetSitterService}
                togglePetSitterForm={togglePetSitterForm}
              />
            </div>
          </div>
        )}
        <Footer />
      </div>
    </div>
  );
}

export default connect(mapStateToProps)(PetsitterShow);
